import React from 'react'
import { Typography, makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import { getFeature } from '@paintscout/util/builder'
import { useClientOptions } from '@paintscout/ui-business'

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    '@media print': {
      display: 'none'
    },
    textAlign: 'center',
    padding: theme.spacing(2, 2, 3),
    '& a': {
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      textDecoration: 'none',
      color: theme.palette.grey[600],
      transition: '0.5s all',
      lineHeight: 0,
      '& p': {
        color: theme.palette.grey[600],
        transition: '0.5s all',
        fontWeight: 500
      }
    },
    '& a:hover': {
      '& p': {
        color: 'black'
      }
    }
  }
}))

function Footer() {
  const classes = useStyles({})
  const { options } = useClientOptions()
  const hasWhiteLabelling = getFeature({ options, path: 'whiteLabelling.enabled' })

  if (hasWhiteLabelling) {
    return <div style={{ height: 28 }}></div>
  } else
    return (
      <footer className={classes.footer}>
        <a href="https://www.paintscout.com" target={'_blank'} rel={'noreferrer noopener'}>
          <Typography variant={'body2'}>Powered by PaintScout</Typography>
        </a>
      </footer>
    )
}

export default Footer
